import React from 'react';

const ErrorClipboardIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="240" height="136" fill="none">
      <path
        d="M204.645 105.734h24.804M169.45 25.201h24.804M8.409 1h24.804M24.488 105.734H154.24M0 105.734h11.28"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="m35.02 15.7 85.672 76.476H40.009l-2.832 1.04-1.905-1.633c-.029-.03-.063-.063-.092-.097a2.112 2.112 0 0 1-.554-1.419V16.923c0-.456.141-.879.389-1.224h.005Z"
        fill="#1C1C1C"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeMiterlimit="10"
      />
      <path
        d="m153.181 16.744-.884 1.977v52.741l-8.253 20.719h-23.352L35.02 15.7a2.111 2.111 0 0 1 1.72-.89h113.454a2.122 2.122 0 0 1 1.501.632l1.491 1.302h-.005Z"
        fill="#DBDBDB"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M150.616 15.908H39.436a3.653 3.653 0 0 0-3.654 3.653v70.594a3.653 3.653 0 0 0 3.654 3.653h111.18a3.653 3.653 0 0 0 3.653-3.653V19.561a3.653 3.653 0 0 0-3.653-3.653Z"
        fill="#fff"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M149.552 23.375V87.48c0 .884-.719 1.603-1.603 1.603H42.326a1.606 1.606 0 0 1-1.608-1.603V23.376c0-.89.719-1.608 1.608-1.608h105.623c.889 0 1.603.718 1.603 1.607Z"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M139.968 31.965h-36.676a4.95 4.95 0 0 0-4.95 4.95v39.669a4.95 4.95 0 0 0 4.95 4.95h36.676a4.95 4.95 0 0 0 4.95-4.95V36.915a4.95 4.95 0 0 0-4.95-4.95Z"
        fill="#E8E8E8"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M89.165 21.768v67.314H42.326a1.606 1.606 0 0 1-1.608-1.603V23.376c0-.89.719-1.608 1.608-1.608h46.839Z"
        stroke="#12183E"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M147.755 48.479h-30.973a3.725 3.725 0 0 0-2.721 1.195l-7.383-8.127c-2.638.471-3.872 4.965-3.872 6.101v22.395c0 1.5.772 2.803 1.919 3.502l.024.02c.189.111.384.204.588.281l9.677 4.66c.116.062.233.12.354.17h.01c.437.179.908.28 1.404.28h30.973c2.118 0 3.838-1.811 3.838-4.046V52.516c0-2.235-1.715-4.047-3.838-4.047v.01Z"
        fill="#1C1C1C"
      />
      <path
        d="m154.551 46.18-6.694 5.436V61.1l-41.777-19.31a4.005 4.005 0 0 1 2.822-1.146h34.904c.855 0 1.647.262 2.298.714l8.447 4.824Z"
        fill="#fff"
      />
      <path
        d="M147.862 61.098v6.009a4.049 4.049 0 0 1-4.051 4.051h-20.01l-5.659 4.596-10.605-4.839a4.225 4.225 0 0 1-.621-.281l-.025-.01a4.065 4.065 0 0 1-2.03-3.512V44.698c0-1.142.471-2.172 1.229-2.905l41.777 19.31-.005-.005Z"
        fill="#969696"
      />
      <path
        d="m154.556 46.244-8.448-4.887a4.009 4.009 0 0 0-2.297-.714h-34.904a4.049 4.049 0 0 0-4.051 4.051v22.419a4.04 4.04 0 0 0 2.031 3.507l.029.015c.199.111.408.204.621.281l10.605 4.839 5.659-4.596h20.015a4.049 4.049 0 0 0 4.051-4.051V51.616l6.694-5.372h-.005Z"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M150.451 45.082h-28.505a6.86 6.86 0 0 0-6.86 6.86v17.852a6.86 6.86 0 0 0 6.86 6.859h28.505a6.858 6.858 0 0 0 6.859-6.86V51.942c0-3.788-3.07-6.859-6.859-6.859Z"
        fill="#FDFDFF"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M138.064 69.46a7.646 7.646 0 1 0 0-15.292 7.647 7.647 0 1 0 0 15.292Z"
        stroke="#12183E"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M138.064 67.784a5.97 5.97 0 1 0 0-11.94 5.97 5.97 0 0 0 0 11.94Z"
        fill="#E8E8E8"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M146.754 123.173c-4.148 0-7.393-1.049-9.778-3.148-6.257-5.508-3.177-15.481-3.041-15.904.058-.185.136-.364.228-.534 10.746-20.005 10.289-29.774 8.011-34.447-1.035-2.128-2.546-3.313-3.756-3.964-1.209-.651-1.787-1.929-1.593-3.23.33-2.167 2.706-3.333 4.63-2.289 2.103 1.132 4.576 3.114 6.295 6.52 4.368 8.666 1.72 22.156-7.864 40.091-.307 1.181-1.516 6.597 1.267 9.031 5.397 4.712 23.439-3.095 30.381-6.325.792-.369.044 1.535.802 1.812.758.277 2.22-.044 1.603 1.477-.369.898-1.05.801.68 2.025.583.413-1.035.889-1.734 1.215-11.008 5.125-19.67 7.675-26.14 7.675l.009-.005Z"
        fill="#0085FF"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeMiterlimit="10"
      />
      <path
        d="M230.115 135.889c5.459 0 9.885-1.154 9.885-2.579 0-1.425-4.426-2.58-9.885-2.58-5.46 0-9.886 1.155-9.886 2.58s4.426 2.579 9.886 2.579Z"
        fill="#1C1C1C"
      />
      <path
        d="M222.012 112.457v20.855c0 .874 3.629 1.583 8.108 1.583 4.479 0 8.107-.709 8.107-1.583v-20.855h-16.215Z"
        fill="#fff"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M230.115 114.04c4.477 0 8.107-.709 8.107-1.583 0-.875-3.63-1.584-8.107-1.584-4.478 0-8.108.709-8.108 1.584 0 .874 3.63 1.583 8.108 1.583Z"
        fill="#fff"
        stroke="#12183E"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="m172.584 102.318-6.777-5.343M177.427 97.839l-1.229-8.54M183.319 100.806l5.854-6.34M184.32 119.85l6.772 5.343M179.583 124.312l1.011 8.57M173.579 121.365l-5.853 6.335"
        stroke="#1C1C1C"
        strokeWidth=".902"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.858 36.74v37.366a2.17 2.17 0 0 1-2.172 2.172H57.313c-.67 0-1.273-.306-1.672-.783a2.14 2.14 0 0 1-.5-1.384V36.74c0-1.2.972-2.172 2.172-2.172h13.373c1.2 0 2.171.972 2.171 2.172Z"
        fill="#1C1C1C"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="m74.762 37.008-3.07-1.934H57.016a.843.843 0 0 0-.84.821l-.54 21.734h17.246l1.875-20.621h.005Z"
        fill="#848584"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeMiterlimit="10"
      />
      <path
        d="m75.233 38.09-2.346 19.538v16.478h-.03a2.17 2.17 0 0 1-2.17 2.171H57.312c-.67 0-1.273-.306-1.671-.782V57.628l2.38-19.82a1.18 1.18 0 0 1 1.166-1.035h14.88c.704 0 1.248.617 1.165 1.317Z"
        fill="#fff"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M72.887 57.955v16.157h-.03a2.17 2.17 0 0 1-2.17 2.172H57.312c-.67 0-1.273-.306-1.671-.783V57.96h17.245v-.005Z"
        fill="#E8E8E8"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeLinejoin="round"
      />
      <path
        d="M83.865 118.32c2.989 0 5.412-.857 5.412-1.914s-2.423-1.914-5.412-1.914-5.411.857-5.411 1.914 2.422 1.914 5.411 1.914ZM210.824 134.186c2.031 0 3.677-.583 3.677-1.302 0-.719-1.646-1.302-3.677-1.302s-3.677.583-3.677 1.302c0 .719 1.646 1.302 3.677 1.302Z"
        fill="#fff"
        stroke="#1C1C1C"
        strokeWidth=".258"
        strokeMiterlimit="10"
      />
      <path
        d="M231.373 112.191a4.328 4.328 0 0 1-.025.292h-.014c-.005.276-.705.495-1.564.495-.753 0-2.356-.17-2.502-.398a1.423 1.423 0 0 1-.136-.535c-.418-6.587-.928-13.747-2.827-15.856-3.848-4.26-10.809.957-23.459 9.371-4.216 2.803-9.73 5.805-17.138 6.131-.549.024 1.326-1.137 1.044-1.803-.282-.665-2.229-.903-1.909-1.603.267-.583 1.467-.539 1.73-.971.437-.719-1.045-2.628-.389-2.429 5.237 1.593 10.182-.296 14.607-3.911 9.371-7.665 22.23-16.336 28.788-9.079 3.152 3.488 4.265 11.445 3.789 20.291l.005.005Z"
        fill="#0085FF"
        stroke="#12183E"
        strokeWidth=".258"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default ErrorClipboardIcon;
